export default __webpack_public_path__ + "media/color/pink-46486597.svg";